import React from 'react';
import {useIntl} from 'react-intl';

import {Button} from '@views/Account/Plan/_components/ActionButtons';
import {useView} from '@views/Account/Plan/_hooks/useView';
import {useNextBoxDate} from '@views/Account/_hooks';
import {ModalOrderSkip} from '@views/Account/Plan/MyPlan/ModalOrderSkip';

const TEXT = {
  BUTTON_SKIP_ORDER: {id: 'account_yourPlan.planPanel.skipOrder'},
};

interface ActionSkipOrderProps {
  onSuccess: () => Promise<void>;
}

export const ActionSkipOrder: React.FC<ActionSkipOrderProps> = ({onSuccess}) => {
  const {formatMessage} = useIntl();
  const {visible, open, close} = useView();
  const {raw: boxDate = new Date()} = useNextBoxDate();

  return (
    <>
      <Button onPress={open}>{formatMessage(TEXT.BUTTON_SKIP_ORDER)}</Button>
      <ModalOrderSkip isVisible={visible} onClose={close} onSuccess={onSuccess} date={boxDate} />
    </>
  );
};
